import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { scrollToError } from '../../../billing/modals/shared/utils';
import { FieldValues } from 'react-hook-form/dist/types/fields';

type NestedFormSubmitButtonProps = {
  buttonText: string;
  handleSubmit: (data: FieldValues) => Promise<void>;
};

export const NestedFormSubmitButton = ({
  buttonText,
  handleSubmit,
}: NestedFormSubmitButtonProps) => {
  const [submitting, setSubmitting] = React.useState(false);
  const {
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();

  const onClick = async () => {
    setSubmitting(true);
    const isValid = await trigger(undefined, { shouldFocus: true });
    if (!isValid) {
      setSubmitting(false);
      if (errors) {
        scrollToError();
      }
      return;
    }
    await handleSubmit(getValues());
    setSubmitting(false);
  };

  return (
    <PrimaryButton loading={submitting} disabled={submitting} onClick={onClick}>
      {buttonText}
    </PrimaryButton>
  );
};
